export default "__VITE_ASSET__hnXBJHgs__"